import { render, staticRenderFns } from "./SupportSection.vue?vue&type=template&id=1463ae34&scoped=true&"
import script from "./SupportSection.vue?vue&type=script&lang=js&"
export * from "./SupportSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportSection.vue?vue&type=style&index=0&id=1463ae34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463ae34",
  null
  
)

export default component.exports